import { render } from "./WithdrawDetails.vue?vue&type=template&id=be84b598&scoped=true"
import script from "./WithdrawDetails.vue?vue&type=script&lang=js"
export * from "./WithdrawDetails.vue?vue&type=script&lang=js"

import "./WithdrawDetails.vue?vue&type=style&index=0&id=be84b598&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be84b598"]])

export default __exports__